import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SectionHeader from "../SectionHeader";
import iosImage from "./img/ios.png";
import androidImage from "./img/android.png";
import appleStore from "../DownloadSlider/img/app-store.png";
import googlePlay from "../DownloadSlider/img/google-play.png";
import "./style.scss";

const GUIDE_URL = "https://www.vuse.com/de/de/vuse-ultra-app/";
const APP_STORE_URL = "https://apps.apple.com/de/app/nuviu/id1616197482";
const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.bat.myvuse.mobile";

const contentByPlatform = {
  ios: {
    image: iosImage,
    imageAlt: "Nuviu App im App Store",
    store: {
      name: "App Store",
      image: appleStore,
      link: APP_STORE_URL,
    },
    steps: [
      {
        title: (
          <>
            Schritt 1: <br />
            <strong>Lade die Nuviu-App herunter</strong>
          </>
        ),
        showStoreBadge: true,
      },
      {
        title: (
          <>
            Schritt 2: <br />
            <strong>Finde die MYVUSE-App in Nuviu</strong>
          </>
        ),
        description: (
          <>
            Nach dem Herunterladen öffnest du Nuviu und{" "}
            <a
              href="https://my.vuse.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              besuchst my.vuse.com
            </a>{" "}
            über den Browser der App.
          </>
        ),
      },
      {
        title: (
          <>
            Schritt 3: <br />
            <strong>Melde dich in der MYVUSE-App an</strong>
          </>
        ),
        description: (
          <>
            Melde dich mit deiner Inspiration Club E-Mail-Adresse an{" "}
            <strong>und verbinde dein Ultra-Gerät.</strong>
          </>
        ),
      },
    ],
  },
  android: {
    image: androidImage,
    imageAlt: "MYVUSE App auf Android",
    store: {
      name: "Google Play",
      image: googlePlay,
      link: GOOGLE_PLAY_URL,
    },
    steps: [
      {
        title: (
          <>
            Schritt 1: <br />
            <strong>Lade die MYVUSE-App herunter</strong>
          </>
        ),
        showStoreBadge: true,
      },
      {
        title: (
          <>
            Schritt 2: <br />
            <strong>Melde dich in der MYVUSE-App an</strong>
          </>
        ),
        description: (
          <>
            Melde dich mit deiner Inspiration Club E-Mail-Adresse an{" "}
            <strong>und verbinde dein Ultra-Gerät.</strong>
          </>
        ),
      },
    ],
  },
};

export default NiceModal.create(({ platform = "ios" }) => {
  const modal = useModal();
  const content = contentByPlatform[platform] || contentByPlatform.ios;

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      disableClose={false}
      onAfterClose={() => modal.remove()}
      innerClass="download-app-modal"
    >
      <div className="content-wrapper">
        <div className="top-content">
          <SectionHeader>
            Die <strong>MYVUSE-App</strong> herunterladen
          </SectionHeader>
        </div>

        <div className="modal-body">
          <div className="instructions">
            <div className="steps">
              {content.steps.map((step, index) => (
                <div className="step" key={index}>
                  <div className="step-header">
                    <p className="step-title">{step.title}</p>
                    {step.showStoreBadge && (
                      <a
                        className="store-badge"
                        href={content.store.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={content.store.image}
                          alt={content.store.name}
                        />
                      </a>
                    )}
                  </div>
                  {step.description && (
                    <p className="step-description">{step.description}</p>
                  )}
                </div>
              ))}
            </div>

            <a
              className="guide-button"
              href={GUIDE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ausführliche Anleitung
            </a>
          </div>

          <div className="visual">
            <img src={content.image} alt={content.imageAlt} />
          </div>
        </div>
      </div>
    </Modal>
  );
});
